import { environment } from '../../../environments/environment';

export class SETTINGS {
  public static ACCESS_TOKEN = '%&^%^*@&*#';
  public static REFRESH_TOKEN = '&@&#&$(@&##';
  public static LOGGED_IN_USER = '#$%@^^%';
  public static USER_PRIVILEGES = '%$^%((*';
  public static PAYMENT = 'F&1cD,hSa*KrvrtLd,*,R-;j,';

  // Local
  // public static BASE_API = "http://localhost:3000";

  // Dev
  // public static BASE_API = "http://164.68.113.179:3003";
  public static BASE_API = environment.serverURL; // Do not change this

  public static CHARGEBEE_SITE = environment.chargebeeSite;

  public static KEYS = {
    SECRET: 'iIUsWtNZcf',
  };

  public static REGEX = {
    PASSWORD: {
      EXP: '^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{8,}$',
    },
    PHONE: {
      EXP: '^[0-9]*$',
    },
    URL: {
      EXP: '^((http|https)://)[-a-zA-Z0-9@:%._\\+~#?&//=]{2,256}\\.[a-z]{2,6}\\b([-a-zA-Z0-9@:%._\\+~#?&//=]*)$',
    },
    ONLY_UPPERCASE_LETTERS: {
      EXP: '^[A-Z]+$',
    },
  };

  public static RECENTLY_ITINERARY = {
    CURRENCY: 'CURRENCY',
    LANGUAGE: 'LANGUAGE',
    AGENT: 'AGENT',
    TYPE: 'TYPE',
    SELECTED_CONTACT: 'SELECTED_CONTACT',
    CUSTOMER: 'CUSTOMER',
  };

  public static MEAL_PLANS = [
    { value: 'RO', label: 'Room Only (RO)',              language: 'en' },
    { value: 'RO', label: 'Chambre uniquement (RO)',     language: 'fr' },
    { value: 'RO', label: 'Nur Übernachtung (RO)',       language: 'de' },
    { value: 'RO', label: 'Solo habitación (RO)',        language: 'es' },
    { value: 'RO', label: 'Только номер (RO)',           language: 'ru' },
    { value: 'BB', label: 'Bed & Breakfast (BB)',        language: 'en' },
    { value: 'BB', label: 'Chambre et petit-déjeuner (BB)', language: 'fr' },
    { value: 'BB', label: 'Übernachtung mit Frühstück (BB)', language: 'de' },
    { value: 'BB', label: 'Cama y desayuno (BB)',        language: 'es' },
    { value: 'BB', label: 'Ночлег с завтраком (BB)',     language: 'ru' },
    { value: 'L',  label: 'Lunch (L)',                   language: 'en' },
    { value: 'L',  label: 'Déjeuner (L)',                language: 'fr' },
    { value: 'L',  label: 'Mittagessen (L)',             language: 'de' },
    { value: 'L',  label: 'Almuerzo (L)',                language: 'es' },
    { value: 'L',  label: 'Обед (L)',                    language: 'ru' },
    { value: 'D',  label: 'Dinner (D)',                  language: 'en' },
    { value: 'D',  label: 'Dîner (D)',                   language: 'fr' },
    { value: 'D',  label: 'Abendessen (D)',              language: 'de' },
    { value: 'D',  label: 'Cena (D)',                    language: 'es' },
    { value: 'D',  label: 'Ужин (D)',                    language: 'ru' },
    { value: 'HB', label: 'Half Board (HB)',             language: 'en' },
    { value: 'HB', label: 'Demi-pension (HB)',           language: 'fr' },
    { value: 'HB', label: 'Halbpension (HB)',            language: 'de' },
    { value: 'HB', label: 'Media pensión (HB)',          language: 'es' },
    { value: 'HB', label: 'Полупансион (HB)',            language: 'ru' },
    { value: 'FB', label: 'Full Board (FB)',             language: 'en' },
    { value: 'FB', label: 'Pension complète (FB)',       language: 'fr' },
    { value: 'FB', label: 'Vollpension (FB)',            language: 'de' },
    { value: 'FB', label: 'Pensión completa (FB)',       language: 'es' },
    { value: 'FB', label: 'Полный пансион (FB)',         language: 'ru' },
    { value: 'AI', label: 'All Inclusive (AI)',          language: 'en' },
    { value: 'AI', label: 'Tout inclus (AI)',            language: 'fr' },
    { value: 'AI', label: 'All Inclusive (AI)',          language: 'de' },
    { value: 'AI', label: 'Todo incluido (AI)',          language: 'es' },
    { value: 'AI', label: 'Всё включено (AI)',           language: 'ru' },
  ];
  public static ROOM_TYPES = [
    { value: 'Single',    label: 'Single',                       language: 'en' },
    { value: 'Single',    label: 'Simple',                       language: 'fr' },
    { value: 'Single',    label: 'Einzelzimmer',                 language: 'de' },
    { value: 'Single',    label: 'Individual',                   language: 'es' },
    { value: 'Single',    label: 'Одноместный',                  language: 'ru' },
    { value: 'Twin',      label: 'Twin',                         language: 'en' },
    { value: 'Twin',      label: 'Lits jumeaux',                 language: 'fr' },
    { value: 'Twin',      label: 'Zweibettzimmer',               language: 'de' },
    { value: 'Twin',      label: 'Doble con camas separadas',    language: 'es' },
    { value: 'Twin',      label: 'Двухместный (раздельные кровати)', language: 'ru' },
    { value: 'Double',    label: 'Double',                       language: 'en' },
    { value: 'Double',    label: 'Double',                       language: 'fr' },
    { value: 'Double',    label: 'Doppelzimmer',                 language: 'de' },
    { value: 'Double',    label: 'Doble',                        language: 'es' },
    { value: 'Double',    label: 'Двухместный',                  language: 'ru' },
    { value: 'Triple',    label: 'Triple',                       language: 'en' },
    { value: 'Triple',    label: 'Triple',                       language: 'fr' },
    { value: 'Triple',    label: 'Dreibettzimmer',               language: 'de' },
    { value: 'Triple',    label: 'Triple',                       language: 'es' },
    { value: 'Triple',    label: 'Трёхместный',                  language: 'ru' },
    { value: 'Quadruple', label: 'Quadruple',                    language: 'en' },
    { value: 'Quadruple', label: 'Quadruple',                    language: 'fr' },
    { value: 'Quadruple', label: 'Vierbettzimmer',               language: 'de' },
    { value: 'Quadruple', label: 'Cuádruple',                    language: 'es' },
    { value: 'Quadruple', label: 'Четырёхместный',               language: 'ru' },
    { value: 'Family',    label: 'Family',                       language: 'en' },
    { value: 'Family',    label: 'Familiale',                    language: 'fr' },
    { value: 'Family',    label: 'Familienzimmer',               language: 'de' },
    { value: 'Family',    label: 'Familiar',                     language: 'es' },
    { value: 'Family',    label: 'Семейный',                     language: 'ru' },
  ];

  public static ENTRY_TYPES = {
    MANUAL: 'manual',
    GOOGLE: 'google',
  };

  public static CONTENT_TYPES = {
    TYPED: 'typed',
    GENERATED: 'generated',
  };

  public static TRANSPORT_TYPES = [
    { value: 'air', label: 'Air' },
    { value: 'land', label: 'Land' },
    { value: 'sea', label: 'Sea' },
    { value: 'train', label: 'Train' },
  ];

  public static ITINERARY_STATUSES = {
    DRAFT: 'Draft',
    SENT: 'Sent',
    FOLLOW_UP: 'Follow Up',
    CONFIRMED: 'Confirmed',
    INVOICE_SENT: 'Invoice Sent',
    PAID: 'Paid',
    LOST: 'Lost',
    CANCELLED: 'Cancelled',
  };

  public static ROOM_CATEGORIES = [
    { value: 'Standard',  label: 'Standard',         language: 'en' },
    { value: 'Standard',  label: 'Standard',         language: 'fr' },
    { value: 'Standard',  label: 'Standard',         language: 'de' },
    { value: 'Standard',  label: 'Estándar',         language: 'es' },
    { value: 'Standard',  label: 'Стандарт',         language: 'ru' },
    { value: 'Deluxe',    label: 'Deluxe',           language: 'en' },
    { value: 'Deluxe',    label: 'Deluxe',           language: 'fr' },
    { value: 'Deluxe',    label: 'Deluxe',           language: 'de' },
    { value: 'Deluxe',    label: 'Deluxe',           language: 'es' },
    { value: 'Deluxe',    label: 'Делюкс',           language: 'ru' },
    { value: 'Executive', label: 'Executive',        language: 'en' },
    { value: 'Executive', label: 'Exécutif',         language: 'fr' },
    { value: 'Executive', label: 'Exekutive',        language: 'de' },
    { value: 'Executive', label: 'Ejecutivo',        language: 'es' },
    { value: 'Executive', label: 'Представительский', language: 'ru' },
    { value: 'Premium',   label: 'Premium',          language: 'en' },
    { value: 'Premium',   label: 'Premium',          language: 'fr' },
    { value: 'Premium',   label: 'Premium',          language: 'de' },
    { value: 'Premium',   label: 'Premium',          language: 'es' },
    { value: 'Premium',   label: 'Премиум',          language: 'ru' },
    { value: 'Suite',     label: 'Suite',            language: 'en' },
    { value: 'Suite',     label: 'Suite',            language: 'fr' },
    { value: 'Suite',     label: 'Suite',            language: 'de' },
    { value: 'Suite',     label: 'Suite',            language: 'es' },
    { value: 'Suite',     label: 'Люкс',             language: 'ru' },
  ];

  public static ITINERARY_TYPES = [
    { value: 'B2C', label: 'B2C' },
    { value: 'B2B', label: 'B2B' },
  ];

  public static ITINERARY_THEME_TYPES = [
    { value: 'THEME_1', label: 'Theme 01' },
    { value: 'THEME_2', label: 'Theme 02' },
    // { value: 'THEME_3', label: 'Theme 03 (In Progress)', disabled: true },
  ];

  public static THEME_TYPES_NAVI_B2C = [
    { value: 'THEME_1', url: '/client/preview/t1' },
    { value: 'THEME_2', url: '/client/preview/t2' },
  ];

  public static THEME_TYPES_NAVI_B2B = [
    { value: 'THEME_1', url: '/btob/preview/t1' },
    { value: 'THEME_2', url: '/btob/preview/t2' },
  ];

  public static THEME_TYPES_NAVI_B2C_TEMPLATE = [
    { value: 'THEME_1', url: '/client/template/preview/t1' },
    { value: 'THEME_2', url: '/client/template/preview/t2' },
  ];

  public static THEME_TYPES_NAVI_B2B_TEMPLATE = [
    { value: 'THEME_1', url: '/btob/template/preview/t1' },
    { value: 'THEME_2', url: '/btob/template/preview/t2' },
  ];

  public static FIXED_PERCENT_SYMBOL = [
    { value: 'PERCENT', label: '%',              emoji: '%',  language: 'en' },
    { value: 'PERCENT', label: '%',              emoji: '%',  language: 'fr' },
    { value: 'PERCENT', label: '%',              emoji: '%',  language: 'de' },
    { value: 'PERCENT', label: '%',              emoji: '%',  language: 'es' },
    { value: 'PERCENT', label: '%',              emoji: '%',  language: 'ru' },
    { value: 'FIXED',   label: 'Fixed',          emoji: '💲', language: 'en' },
    { value: 'FIXED',   label: 'Fixe',           emoji: '💲', language: 'fr' },
    { value: 'FIXED',   label: 'Fest',           emoji: '💲', language: 'de' },
    { value: 'FIXED',   label: 'Fijo',           emoji: '💲', language: 'es' },
    { value: 'FIXED',   label: 'Фиксированный',  emoji: '💲', language: 'ru' },
  ];

  public static FIXED_PERCENT_SYMBOL_OBJECT = {
    PERCENT: 'PERCENT',
    FIXED: 'FIXED',
  };

  public static MILEAGE_UNIT = [
    { value: 'km',    label: 'Km',     language: 'en' },
    { value: 'km',    label: 'Km',     language: 'fr' },
    { value: 'km',    label: 'km',     language: 'de' },
    { value: 'km',    label: 'km',     language: 'es' },
    { value: 'km',    label: 'км',     language: 'ru' },
    { value: 'miles', label: 'Miles',  language: 'en' },
    { value: 'miles', label: 'Miles',  language: 'fr' },
    { value: 'miles', label: 'Meilen', language: 'de' },
    { value: 'miles', label: 'Millas', language: 'es' },
    { value: 'miles', label: 'Мили',   language: 'ru' },
  ];

  public static ITINERARY_MESSAGE_STATUS = {
    ADD_SUCCESS: 'addSuccess',
    EDIT_SUCCESS: 'editSuccess',
    ERROR: 'error',
  };

  public static ITINERARY_CONTENT_MODE = {
    NEW: 'new',
    EDIT: 'edit',
  };

  public static ENTRY_TYPE = {
    CREATE: 'create',
    UPDATE: 'update',
  };

  public static ITINERARY_DELETE_CONTENT_MESSAGES = {
    DESTINATION: 'Destination has been deleted',
    ACCOMMODATION: 'Accommodation has been deleted',
    TRANSPORTATION: 'Transportation has been deleted',
    EXPERIENCES: 'Experiences  has been deleted',
    ERROR: 'Something went wrong',
  };

  public static SETTINGS_TAB_KEYS = {
    BRANDING: 'branding',
    ACCOUNT: 'account',
    PREFERENCES: 'preferences',
    BILLING: 'billing',
  };

  public static TAB_KEYS = {
    BRANDING: 'branding',
    ACCOUNT: 'account',
    PREFERENCES: 'preferences',
    BILLING: 'billing',
  };

  public static MANAGE_PARAMETERS_TAB_KEYS = {
    CATEGORIES: 'room-categories',
    ROOM_TYPES: 'room-types',
    MEAL_PLANS: 'meal-plans',
  };

  public static ITINERARY_CONTENT_MESSAGES = {
    DESTINATION: 'New Destination has been added',
    DESTINATION_EDIT: 'Destination has updated',
    ACCOMMODATION: ' New Accommodation has been added',
    ACCOMMODATION_EDIT: 'Accommodation has updated',
    TRANSPORTATION: ' New Transportation has been added',
    TRANSPORTATION_EDIT: 'Transportation has updated',
    EXPERIENCES: ' New Experiences  has been added',
    EXPERIENCES_EDIT: 'Experiences  has updated',
    ERROR: 'Something went wrong',
  };

  public static PREDEFINED_COST_MODE = {
    NEW: 'new',
    EDIT: 'edit',
  };

  public static MAP_BOX_ACCESS = {
    TOKEN:
      'pk.eyJ1IjoicHVycGxlc29mdHdhcmUiLCJhIjoiY20zbWpweWRnMHp6eDJpb25kZDVmZmNlMCJ9.STHwcMr5DKx_ZP9HDkyUmg',
  };

  public static FEATURE_TOOLTIP_TEXT = {
    ITINERARY:    'nav.featureTooltips.itinerary',
    DASHBOARD:    'nav.featureTooltips.dashboard',
    CUSTOMER:     'nav.featureTooltips.customer',
    AGENT:        'nav.featureTooltips.agent',
    RATES:        'nav.featureTooltips.rates',
    DESTINATION:  'nav.featureTooltips.destination',
    EXPERIENCES:  'nav.featureTooltips.experiences',
    OTHER:        'nav.featureTooltips.other',
    USERS:        'nav.featureTooltips.users',
    ROLES:        'nav.featureTooltips.roles',
    SETTING:      'nav.featureTooltips.setting',
  };

  public static VIEW_TYPES = [
    { value: 'total',  label: 'Total Tour Cost - Auto Calculated',         language: 'en' },
    { value: 'total',  label: 'Coût total du voyage - Calculé auto.',      language: 'fr' },
    { value: 'total',  label: 'Gesamtreisekosten - Auto berechnet',        language: 'de' },
    { value: 'total',  label: 'Costo total del viaje - Auto calculado',    language: 'es' },
    { value: 'total',  label: 'Общая стоимость - Авторасчёт',             language: 'ru' },
    { value: 'person', label: 'Per Person Cost - Auto Calculated',         language: 'en' },
    { value: 'person', label: 'Coût par pers. - Calculé auto.',            language: 'fr' },
    { value: 'person', label: 'Kosten pro Person - Auto berechnet',        language: 'de' },
    { value: 'person', label: 'Costo por persona - Auto calculado',        language: 'es' },
    { value: 'person', label: 'На человека - Авторасчёт',                 language: 'ru' },
    { value: 'custom', label: 'Custom Per Person Cost',                    language: 'en' },
    { value: 'custom', label: 'Coût pers. personnalisé',                   language: 'fr' },
    { value: 'custom', label: 'Benutzerdefiniert pro Person',              language: 'de' },
    { value: 'custom', label: 'Costo personalizado por persona',           language: 'es' },
    { value: 'custom', label: 'Произвольная стоимость',                   language: 'ru' },
  ];

  public static VIEW_TYPES_B2B = [
    { value: 'total',  label: 'Total Tour Cost',                           language: 'en' },
    { value: 'total',  label: 'Coût total du voyage',                      language: 'fr' },
    { value: 'total',  label: 'Gesamtreisekosten',                         language: 'de' },
    { value: 'total',  label: 'Costo total del viaje',                     language: 'es' },
    { value: 'total',  label: 'Общая стоимость тура',                     language: 'ru' },
    { value: 'person', label: 'Per Person Cost',                           language: 'en' },
    { value: 'person', label: 'Coût par personne',                         language: 'fr' },
    { value: 'person', label: 'Kosten pro Person',                         language: 'de' },
    { value: 'person', label: 'Costo por persona',                         language: 'es' },
    { value: 'person', label: 'Стоимость на человека',                    language: 'ru' },
    { value: 'custom', label: 'Custom Per Person Cost',                    language: 'en' },
    { value: 'custom', label: 'Coût personnalisé par personne',            language: 'fr' },
    { value: 'custom', label: 'Benutzerdefinierte Kosten pro Person',      language: 'de' },
    { value: 'custom', label: 'Costo personalizado por persona',           language: 'es' },
    { value: 'custom', label: 'Произвольная стоимость на человека',       language: 'ru' },
  ];

  public static COMMON_ERROR = {
    ORG_EMAIL_EXISTS:
      'OrganizationSetting validation failed: email: email must be unique',
  };

  public static MAP_TYPES = [
    { value: 'NAV', label: 'Navigation Path',          language: 'en' },
    { value: 'NAV', label: 'Itinéraire de navigation', language: 'fr' },
    { value: 'NAV', label: 'Navigationsroute',         language: 'de' },
    { value: 'NAV', label: 'Ruta de navegación',       language: 'es' },
    { value: 'NAV', label: 'Маршрут навигации',        language: 'ru' },
    { value: 'STR', label: 'Straight Line',            language: 'en' },
    { value: 'STR', label: 'Ligne droite',             language: 'fr' },
    { value: 'STR', label: 'Gerade Linie',             language: 'de' },
    { value: 'STR', label: 'Línea recta',              language: 'es' },
    { value: 'STR', label: 'Прямая линия',             language: 'ru' },
  ];

  // DON'T CHANGE THE ORDER OF THE ARRAY
  public static CONDITION_TYPES = [
    { value: 'INC', label: 'Included',        language: 'en' },
    { value: 'INC', label: 'Inclus',          language: 'fr' },
    { value: 'INC', label: 'Inklusive',       language: 'de' },
    { value: 'INC', label: 'Incluido',        language: 'es' },
    { value: 'INC', label: 'Включено',        language: 'ru' },
    { value: 'EXC', label: 'Excluded',        language: 'en' },
    { value: 'EXC', label: 'Exclu',           language: 'fr' },
    { value: 'EXC', label: 'Ausgeschlossen',  language: 'de' },
    { value: 'EXC', label: 'Excluido',        language: 'es' },
    { value: 'EXC', label: 'Исключено',       language: 'ru' },
    { value: 'OPT', label: 'Optional',        language: 'en' },
    { value: 'OPT', label: 'Optionnel',       language: 'fr' },
    { value: 'OPT', label: 'Optional',        language: 'de' },
    { value: 'OPT', label: 'Opcional',        language: 'es' },
    { value: 'OPT', label: 'Необязательно',   language: 'ru' },
    { value: 'NA',  label: 'N/A',             language: 'en' },
    { value: 'NA',  label: 'N/A',             language: 'fr' },
    { value: 'NA',  label: 'N/A',             language: 'de' },
    { value: 'NA',  label: 'N/A',             language: 'es' },
    { value: 'NA',  label: 'Н/Д',             language: 'ru' },
  ];

  public static RICH_TEXTS = {
    INCLUDED_RICH: '<p>---</p><p>Experiences Included</p>',
    EXCLUDED_RICH: '<p>---</p><p>Experiences Excluded</p>',
    END_RICH: '<p>---</p>',
  };

  public static PERIOD_UNIT = {
    YEAR: 'year',
    MONTH: 'month',
  };

  public static PDF_VIEW_OPTIONS = {
    // Destination
    dest_Description: true,
    dest_Image: true,

    // Experiences
    exp_Image: true,
    exp_Description: true,

    // General
    gen_DisplayMap: true,
    gen_ItineraryBannerImage: true,
    gen_SummaryTable: true,

    // Export Format
    exportFormat: 'pdf',
  };

  public static QUARTERLY_VALUES = [
    { label: 'Q1', value: 1 },
    { label: 'Q2', value: 2 },
    { label: 'Q3', value: 3 },
    { label: 'Q4', value: 4 },
  ];

  public static RATES_SCREEN_TYPES = {
    PARAMETER: 'PARAMETER',
    CONTRACT_FORM: 'CONTRACT_FORM',
  };

  public static COST_TYPES_EXPERIENCES = [
    { value: 'free',      label: 'Free',        language: 'en' },
    { value: 'free',      label: 'Gratuit',     language: 'fr' },
    { value: 'free',      label: 'Kostenlos',   language: 'de' },
    { value: 'free',      label: 'Gratis',      language: 'es' },
    { value: 'free',      label: 'Бесплатно',   language: 'ru' },
    { value: 'perPerson', label: 'Per Person',  language: 'en' },
    { value: 'perPerson', label: 'Par personne',language: 'fr' },
    { value: 'perPerson', label: 'Pro Person',  language: 'de' },
    { value: 'perPerson', label: 'Por persona', language: 'es' },
    { value: 'perPerson', label: 'На человека', language: 'ru' },
    { value: 'perGroup',  label: 'Per Group',   language: 'en' },
    { value: 'perGroup',  label: 'Par groupe',  language: 'fr' },
    { value: 'perGroup',  label: 'Pro Gruppe',  language: 'de' },
    { value: 'perGroup',  label: 'Por grupo',   language: 'es' },
    { value: 'perGroup',  label: 'На группу',   language: 'ru' },
  ];

  public static VERSION = '1.30.5';
}
